import React from 'react'
import { isEmpty } from 'ramda'
import { Text, csx, cx } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

import { useGifts } from '../../hooks/useGifts'
import { GiftListItem } from './GiftListItem'
import type { GiftItem } from '../../../../../../core/requests/checkout'

export type GiftListProps = React.ComponentProps<'div'>

// TODO: this error popped up when moving the checkout-instore project
// to checkout-instore-legacy, but needs to be fixed at some point
// eslint-disable-next-line react/prop-types
export const GiftList = ({ className = '' }: GiftListProps) => {
  const {
    selectableGifts,
    itemInLoading,
    selectGift,
    getGroupSelectedQuantityByItemId,
  } = useGifts()

  if (isEmpty(selectableGifts)) {
    return null
  }

  const checkIfItemIsDisabled = (item: GiftItem, availableQuantity: number) => {
    return (
      !item.isSelected &&
      availableQuantity === getGroupSelectedQuantityByItemId(item.id)
    )
  }

  return (
    <div
      className={cx(
        csx({
          display: 'flex',
          flexDirection: 'column',
        }),
        className
      )}
    >
      {selectableGifts.map((selectableGift) => (
        <div
          key={selectableGift.id}
          data-testid="gift-group"
          className={csx({
            display: 'flex',
            flexDirection: 'column',
            gap: '$space-3',
            paddingY: '$space-5',
            ':first-child': {
              borderTop: '$neutral',
            },
            ':not(:last-child)': {
              borderBottom: '$neutral',
            },
          })}
        >
          <Text variant="title1">
            <FormattedMessage
              id="cart.gift-selection.title"
              values={{ quantity: selectableGift.availableQuantity }}
            />
          </Text>
          <div
            data-testid="gift-list"
            className={csx({
              display: 'flex',
              gap: '$space-2',
              overflowX: 'auto',
            })}
          >
            {selectableGift.availableGifts.map((item) => (
              <GiftListItem
                key={item.id}
                item={item}
                isLoading={itemInLoading === (item.uniqueId ?? item.id)}
                isDisabled={checkIfItemIsDisabled(
                  item,
                  selectableGift.availableQuantity
                )}
                isSelectable={!itemInLoading}
                onSelectItem={selectGift}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
